<p-dialog
    id="unsaved-changes-modal"
    class="custom-modal modal-warning"
    tabindex="0"
    pAutoFocus
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [focusOnShow]="true"
    [(visible)]="isVisible"
    (onHide)="onHide()">
    <ng-template pTemplate="header">
        <h3 class="modal-title">
            <i class="fa-regular fa-do-not-enter"></i> {{ 'unsavedChangesModalTitle' | translate }}
        </h3>
    </ng-template>

    <div class="container">
        <p>{{ unsavedChangesModalScopeText | translate: { scope } }}</p>
        <p>{{ unsavedChangesModalScopeText2 | translate }}</p>
        <p-divider></p-divider>
    </div>

    <div class="footer">
        <p-button id="continue-editing-btn" [outlined]="true" severity="secondary" (click)="onHide()">
            {{ continueButtonText | translate }}
        </p-button>
        <p-button id="leave-without-saving-btn" severity="warning" (click)="onLeavePage()">
            {{ 'leaveWithoutSaving' | translate }}
        </p-button>
    </div>
</p-dialog>
